import React from "react";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export default function FavoriteButton({ poolId, className = "" }) {
  const { user, favorites, refreshFavorites } = useApp();
  const isFav = favorites.includes(poolId);
  const toggle = async (e) => {
    e.preventDefault(); e.stopPropagation();
    if (!user) { toast.error("Please sign in first"); return; }
    try {
      if (isFav) await api.delete(`/favorites/${poolId}`);
      else await api.post(`/favorites/${poolId}`);
      refreshFavorites();
    } catch { toast.error("Failed"); }
  };
  return (
    <button onClick={toggle} className={`w-9 h-9 rounded-full bg-white/95 backdrop-blur flex items-center justify-center hover:bg-white transition shadow-sm ${className}`} data-testid={`fav-${poolId}`}>
      <Heart className={`w-4 h-4 transition ${isFav ? "fill-[#E27B58] text-[#E27B58]" : "text-[#1A202C]"}`} />
    </button>
  );
}
